// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__YpkLa","input":"styles_input__A3NA5","btn_submit":"styles_btn_submit__fdql3"};